'use strict';

angular.module('bringgApp').factory('BringgCommonUtils', function () {
	return CommonUtils;
});
